"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedIds = exports.checkSubset = void 0;
const getSelectedIds = (typeSelectedIds, isSelected, id) => {
  if (!typeSelectedIds) return null;
  return isSelected ? typeSelectedIds.filter(_id => _id !== id) : typeSelectedIds.indexOf(id) >= 0 ? typeSelectedIds : [id, ...typeSelectedIds];
};
exports.getSelectedIds = getSelectedIds;
const checkSubset = (parentArray, subsetArray) => {
  return subsetArray.every(el => {
    return parentArray.includes(el);
  });
};
exports.checkSubset = checkSubset;